import { gql } from '@apollo/client'

const BASE_TEXT_FEEDBACK_FIELDS = gql`
  fragment BaseTextFeedbackFields on TextFeedbackType {
    id
    shortFeedback
    fullFeedback
    order
    student {
      avatar
      fullName
      score
    }
  }
`

export const GET_LIST_TEXT_FEEDBACK = gql`
  ${BASE_TEXT_FEEDBACK_FIELDS}
  query findAllTextFeedback($params: TextFeedbackQueryInput = {}) {
    findAllTextFeedback(query: $params) {
      count
      items {
        ...BaseTextFeedbackFields
        getStudentAvatar {
          photo
        }
      }
    }
  }
`

export const GET_ONE_TEXT_FEEDBACK = gql`
  ${BASE_TEXT_FEEDBACK_FIELDS}
  query findOneTextFeedback($params: String!) {
    findOneTextFeedback(id: $params) {
      ...BaseTextFeedbackFields
      getStudentAvatar {
        photo
      }
    }
  }
`

export const CREATE_TEXT_FEEDBACK = gql`
  ${BASE_TEXT_FEEDBACK_FIELDS}
  mutation createTextFeedback($params: CreateTextFeedbackInput!) {
    createTextFeedback(createTextFeedbackInput: $params) {
      ...BaseTextFeedbackFields
      getStudentAvatar {
        photo
      }
    }
  }
`

export const UPDATE_TEXT_FEEDBACK = gql`
  ${BASE_TEXT_FEEDBACK_FIELDS}
  mutation updateTextFeedback($params: UpdateTextFeedbackInput!) {
    updateTextFeedback(updateTextFeedbackInputFieldName: $params) {
      ...BaseTextFeedbackFields
      getStudentAvatar {
        photo
      }
    }
  }
`

export const DELETE_TEXT_FEEDBACK = gql`
  mutation removeTextFeedback($params: String!) {
    removeTextFeedback(id: $params) {
      affected
    }
  }
`

export const BULK_UPDATE_TEXT_FEEDBACK = gql`
  mutation bulkUpdateTextFeedback($bulkUpdateTextFeedbackInput: [BulkUpdateTextFeedbackInput!]!) {
    bulkUpdateTextFeedback(bulkUpdateTextFeedbackInput: $bulkUpdateTextFeedbackInput) {
      id
    }
  }
`
